import { render, staticRenderFns } from "./UpOrder.vue?vue&type=template&id=199e1177&scoped=true&"
import script from "./UpOrder.vue?vue&type=script&lang=js&"
export * from "./UpOrder.vue?vue&type=script&lang=js&"
import style0 from "./UpOrder.vue?vue&type=style&index=0&id=199e1177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199e1177",
  null
  
)

export default component.exports